// aws cloud
export const url = process.env.REACT_APP_API_BASE_URL || 'https://aolparkingserver.com';
// export const url = 'https://aolparkingserver.com';